import { Box, Link, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const ContactMethod = () => {
    const theme = useTheme();

    return (
        <Box sx={(t) => ({ marginBottom: '40px', [t.breakpoints.down('md')]: { marginBottom: '20px' } })}>
            <Box sx={{ display: 'flex', gap: '16px' }}>
                <Typography
                    sx={(t) => ({
                        fontSize: '20px',
                        fontWeight: 400,
                        lineHeight: '40px',
                        color: '#787878',
                        [t.breakpoints.down('md')]: {
                            fontSize: '16px'
                        }
                    })}
                >
                    T.
                </Typography>
                <Link
                    variant="body1"
                    href="tel:+85237282400"
                    sx={(t) => ({
                        fontSize: '20px',
                        fontWeight: 400,
                        lineHeight: '40px',
                        color: '#787878',
                        textDecorationColor: '#787878',
                        [t.breakpoints.down('md')]: {
                            fontSize: '16px',
                            textDecorationColor: 'transparent'
                        }
                    })}
                >
                    +852 3728 2400
                </Link>
                <Typography
                    sx={(t) => ({
                        fontSize: '20px',
                        fontWeight: 400,
                        lineHeight: '40px',
                        color: '#787878',
                        [t.breakpoints.down('md')]: {
                            fontSize: '16px'
                        }
                    })}
                >
                    |
                </Typography>
                <Link
                    variant="body1"
                    href="tel:+85237282405"
                    sx={(t) => ({
                        fontSize: '20px',
                        fontWeight: 400,
                        lineHeight: '40px',
                        color: '#787878',
                        textDecorationColor: '#787878',
                        [t.breakpoints.down('md')]: {
                            fontSize: '16px',
                            textDecorationColor: 'transparent'
                        }
                    })}
                >
                    +852 3728 2405
                </Link>
            </Box>
            <Box sx={{ display: 'flex', gap: '16px' }}>
                <Typography
                    sx={(t) => ({
                        fontSize: '20px',
                        fontWeight: 400,
                        lineHeight: '40px',
                        color: '#787878',
                        [t.breakpoints.down('md')]: {
                            fontSize: '16px'
                        }
                    })}
                >
                    A.
                </Typography>
                <Typography
                    sx={(t) => ({
                        fontSize: '20px',
                        fontWeight: 400,
                        lineHeight: '40px',
                        color: '#787878',
                        [t.breakpoints.down('md')]: {
                            fontSize: '16px'
                        }
                    })}
                >
                    20/F., Harbourside HQ,
                    <br />
                    8 Lam Chak Street,
                    <br />
                    Kowloon Bay, Hong Kong.
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: '16px' }}>
                <Typography
                    sx={(t) => ({
                        fontSize: '20px',
                        fontWeight: 400,
                        lineHeight: '40px',
                        color: '#787878',
                        [t.breakpoints.down('md')]: {
                            fontSize: '16px'
                        }
                    })}
                >
                    F.
                </Typography>
                <Link
                    variant="body1"
                    href="tel:+85228516601"
                    sx={(t) => ({
                        fontSize: '20px',
                        fontWeight: 400,
                        lineHeight: '40px',
                        color: '#787878',
                        textDecorationColor: '#787878',
                        [t.breakpoints.down('md')]: {
                            fontSize: '16px',
                            textDecorationColor: 'transparent'
                        }
                    })}
                >
                    +852 2851 6601
                </Link>
            </Box>
        </Box>
    );
};

export default ContactMethod;
